// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"ReportModal_AddNewGoalPop__O5Mm3","modalBody":"ReportModal_modalBody__aUNN3","formControl":"ReportModal_formControl__fjkbA","add":"ReportModal_add__AzszX"};